
// Footer accordion
$(".footer-block--menu .footer-block__heading").on("click", (e) => {
  const $curr = $(e.currentTarget);
  const isActived = $curr.hasClass("active");
  // const $menuItem = $curr.closest(".footer-block--menu");
  const $contentWrapper = $curr.parent().find(".footer-block__details-content-wrapper");
  const $content = $curr.parent().find(".footer-block__details-content");
  console.log($contentWrapper)
  if (isActived) {
    $contentWrapper.css("height", 0);
    $curr.removeClass("active");
  } else {
    $contentWrapper.css("height", $content[0].clientHeight);
    $curr.addClass("active");
  }
});

// Update footer menu height
window.addEventListener("resize", () => {
  if (window.innerWidth >= 750) return;
  $(".footer-block--menu").each((i, el) => {
    const $el = $(el);
    const $contentWrapper = $el.parent().find(".footer-block__details-content-wrapper");
    const $content = $el.parent().find(".footer-block__details-content");
    if ($el.hasClass("active")) {
      $contentWrapper.css("height", $content[0].clientHeight);
    }
  });
});